// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Textarea_bottomBorder__7xQHj {
  border-bottom: 1px solid #979797;
}
.Textarea_allBorder__Q2\\+ue {
  border: 1px solid #979797;
  border-radius: 4px;
}
.Textarea_purpleBorder__h2lRX {
  border-color: #6734d6;
  border-width: 2px;
}
.Textarea_greyBorder__Mp4cn {
  border-color: #979797;
  border-width: 1px;
}
.Textarea_redBorder__LH1As {
  border-color: #ff3333;
  border-width: 2px;
}
.Textarea_disabledBottomBorder__dJXzA {
  /* border-color: rgba(0, 0, 0, 0.38);
  border-width: 1px;
  border-style: dashed; */
  border-bottom: 1px dashed rgba(0, 0, 0, 0.38);
  background-color: #efefef !important;
}
.Textarea_disabledOspBorder__g4VOR {
  border-color: rgba(0, 0, 0, 0.38);
  border-width: 1px;
}
.Textarea_pinkBorder__GyQIA {
  border-color: #e04c76;
  border-width: 2px;
}
.Textarea_disabledColor__IKpMU {
  color: rgba(0, 0, 0, 0.38);
  fill: rgba(0, 0, 0, 0.38);
}
.Textarea_pinkColor__G\\+YAW {
  color: #e04c76;
  fill: #e04c76;
}
.Textarea_purpleColor__SRlJN {
  color: #6734d6;
  fill: #6734d6;
}
.Textarea_greyColor__2M5o- {
  color: rgb(148, 148, 148);
  fill: rgb(148, 148, 148);
}
.Textarea_redColor__GtlkW {
  color: #ff3333;
  fill: #ff3333;
}
.Textarea_container__M5\\+1Y {
  position: relative;
  width: 100%;
  background-color: transparent;
}
.Textarea_fSixBackground__8cEsN {
  background-color: #f6f6f6;
}
.Textarea_transparentBgc__eVUvk {
  background-color: transparent;
}
.Textarea_label__08PBr {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: absolute;
  z-index: 0;
  transition: all 0.2s ease-out;
  line-height: 1.6;
  padding: 0 4px;
  border-radius: 5px;
  margin-inline-start: 10px;
}
.Textarea_labelMrginStart__zf-fW {
  margin-inline-start: 12px;
}
.Textarea_labelUp__Wwre2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 23px;
  padding: 0px;
  /* top: 5px; */
  top: -35px;
  cursor: default;
}
.Textarea_labelUpMore__2lSog {
  font-weight: 400;
  font-size: 12px;
  line-height: 23px;
  top: -12px;
  cursor: default;
}
.Textarea_labelDown__OvJoL {
  width: calc(100% - 24px) !important;
  top: 18px;
  font-size: 16px;
  font-weight: 500;
  cursor: text;
}
.Textarea_textarea__GOA-G {
  resize: none;
  overflow-y: hidden;
  width: 100%;
  min-height: 250px;
  outline: none;
  line-height: 25px;
  font-weight: 400;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-out;
  background-color: #f5f5f5;
}
.Textarea_allBorderTextarea__Cpe-k {
  padding: 16px;
}
.Textarea_bottomBorderTextArea__jZPL- {
  padding-block-start: 12px;
  padding-block-end: 5px;
  padding-inline: 16px;
  /* background-color: #efefef3b; */
}
.Textarea_ltrInput__wpvta {
  direction: ltr;
}
.Textarea_helperTxtContainer__\\+m2SS {
  display: flex;
  align-items: center;
  column-gap: 6px;
  height: 29px;
}
.Textarea_helperTxtIcon__01hHS {
  display: flex;
  align-items: center;
  color: #737373;
  fill: #737373;
}
.Textarea_helperTxt__SeHuA {
  color: #737373;
  fill: #737373;
  line-height: 29px;
  font-size: 14px;
}
.Textarea_questionIcon__0ql4c {
  width: 20px;
  height: 20px;
  margin-top: -2px;
}
.Textarea_tooltip__UaFZ7 {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 4px;
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.4s;
  z-index: 1;
  pointer-events: none; /* Prevent the tooltip from interfering with cursor */
  font-size: 12px;
  width: 100%;
}
.Textarea_container__M5\\+1Y:hover .Textarea_tooltip__UaFZ7 {
  visibility: visible;
  opacity: 1;
}
.Textarea_tooltip__UaFZ7::after {
  content: "";
  position: absolute;
  top: 100%; /* Position the arrow at the bottom of the tooltip */
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px; /* Size of the arrow */
  border-style: solid;
  border-color: #333 transparent transparent transparent; /* Triangle color and transparent sides */
}

.Textarea_notif__cB-n7 {
  margin: 0px 5px;
  color: #e09b4c;
  fill: #e0a54c;
  transform: translateY(10px);
}
.Textarea_hcmContainer__P76NW {
  border-radius: 16px;
  border: 1px solid #2979ff;
  padding: 16px;
}
.Textarea_hcmTextarea__OMfk3 {
  width: 100% !important;
  min-height: 140px;
  font-size: 17px;
  font-weight: 400;
  resize: vertical;
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/Textarea/Textarea.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE;;yBAEuB;EACvB,6CAA6C;EAC7C,oCAAoC;AACtC;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,wBAAwB;EACxB,UAAU;EACV,oBAAoB,EAAE,qDAAqD;EAC3E,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,oDAAoD;EAC/D,SAAS;EACT,2BAA2B;EAC3B,iBAAiB,EAAE,sBAAsB;EACzC,mBAAmB;EACnB,sDAAsD,EAAE,yCAAyC;AACnG;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B","sourcesContent":[".bottomBorder {\r\n  border-bottom: 1px solid #979797;\r\n}\r\n.allBorder {\r\n  border: 1px solid #979797;\r\n  border-radius: 4px;\r\n}\r\n.purpleBorder {\r\n  border-color: #6734d6;\r\n  border-width: 2px;\r\n}\r\n.greyBorder {\r\n  border-color: #979797;\r\n  border-width: 1px;\r\n}\r\n.redBorder {\r\n  border-color: #ff3333;\r\n  border-width: 2px;\r\n}\r\n.disabledBottomBorder {\r\n  /* border-color: rgba(0, 0, 0, 0.38);\r\n  border-width: 1px;\r\n  border-style: dashed; */\r\n  border-bottom: 1px dashed rgba(0, 0, 0, 0.38);\r\n  background-color: #efefef !important;\r\n}\r\n.disabledOspBorder {\r\n  border-color: rgba(0, 0, 0, 0.38);\r\n  border-width: 1px;\r\n}\r\n.pinkBorder {\r\n  border-color: #e04c76;\r\n  border-width: 2px;\r\n}\r\n.disabledColor {\r\n  color: rgba(0, 0, 0, 0.38);\r\n  fill: rgba(0, 0, 0, 0.38);\r\n}\r\n.pinkColor {\r\n  color: #e04c76;\r\n  fill: #e04c76;\r\n}\r\n.purpleColor {\r\n  color: #6734d6;\r\n  fill: #6734d6;\r\n}\r\n.greyColor {\r\n  color: rgb(148, 148, 148);\r\n  fill: rgb(148, 148, 148);\r\n}\r\n.redColor {\r\n  color: #ff3333;\r\n  fill: #ff3333;\r\n}\r\n.container {\r\n  position: relative;\r\n  width: 100%;\r\n  background-color: transparent;\r\n}\r\n.fSixBackground {\r\n  background-color: #f6f6f6;\r\n}\r\n.transparentBgc {\r\n  background-color: transparent;\r\n}\r\n.label {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  z-index: 0;\r\n  transition: all 0.2s ease-out;\r\n  line-height: 1.6;\r\n  padding: 0 4px;\r\n  border-radius: 5px;\r\n  margin-inline-start: 10px;\r\n}\r\n.labelMrginStart {\r\n  margin-inline-start: 12px;\r\n}\r\n.labelUp {\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 23px;\r\n  padding: 0px;\r\n  /* top: 5px; */\r\n  top: -35px;\r\n  cursor: default;\r\n}\r\n.labelUpMore {\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  line-height: 23px;\r\n  top: -12px;\r\n  cursor: default;\r\n}\r\n.labelDown {\r\n  width: calc(100% - 24px) !important;\r\n  top: 18px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  cursor: text;\r\n}\r\n.textarea {\r\n  resize: none;\r\n  overflow-y: hidden;\r\n  width: 100%;\r\n  min-height: 250px;\r\n  outline: none;\r\n  line-height: 25px;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease-out;\r\n  background-color: #f5f5f5;\r\n}\r\n.allBorderTextarea {\r\n  padding: 16px;\r\n}\r\n.bottomBorderTextArea {\r\n  padding-block-start: 12px;\r\n  padding-block-end: 5px;\r\n  padding-inline: 16px;\r\n  /* background-color: #efefef3b; */\r\n}\r\n.ltrInput {\r\n  direction: ltr;\r\n}\r\n.helperTxtContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 6px;\r\n  height: 29px;\r\n}\r\n.helperTxtIcon {\r\n  display: flex;\r\n  align-items: center;\r\n  color: #737373;\r\n  fill: #737373;\r\n}\r\n.helperTxt {\r\n  color: #737373;\r\n  fill: #737373;\r\n  line-height: 29px;\r\n  font-size: 14px;\r\n}\r\n.questionIcon {\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-top: -2px;\r\n}\r\n.tooltip {\r\n  visibility: hidden;\r\n  background-color: #333;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 5px 10px;\r\n  border-radius: 4px;\r\n  position: absolute;\r\n  bottom: calc(100% + 10px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  opacity: 0;\r\n  transition: opacity 0.4s;\r\n  z-index: 1;\r\n  pointer-events: none; /* Prevent the tooltip from interfering with cursor */\r\n  font-size: 12px;\r\n  width: 100%;\r\n}\r\n.container:hover .tooltip {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.tooltip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%; /* Position the arrow at the bottom of the tooltip */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-width: 5px; /* Size of the arrow */\r\n  border-style: solid;\r\n  border-color: #333 transparent transparent transparent; /* Triangle color and transparent sides */\r\n}\r\n\r\n.notif {\r\n  margin: 0px 5px;\r\n  color: #e09b4c;\r\n  fill: #e0a54c;\r\n  transform: translateY(10px);\r\n}\r\n.hcmContainer {\r\n  border-radius: 16px;\r\n  border: 1px solid #2979ff;\r\n  padding: 16px;\r\n}\r\n.hcmTextarea {\r\n  width: 100% !important;\r\n  min-height: 140px;\r\n  font-size: 17px;\r\n  font-weight: 400;\r\n  resize: vertical;\r\n  background-color: transparent;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bottomBorder": `Textarea_bottomBorder__7xQHj`,
	"allBorder": `Textarea_allBorder__Q2+ue`,
	"purpleBorder": `Textarea_purpleBorder__h2lRX`,
	"greyBorder": `Textarea_greyBorder__Mp4cn`,
	"redBorder": `Textarea_redBorder__LH1As`,
	"disabledBottomBorder": `Textarea_disabledBottomBorder__dJXzA`,
	"disabledOspBorder": `Textarea_disabledOspBorder__g4VOR`,
	"pinkBorder": `Textarea_pinkBorder__GyQIA`,
	"disabledColor": `Textarea_disabledColor__IKpMU`,
	"pinkColor": `Textarea_pinkColor__G+YAW`,
	"purpleColor": `Textarea_purpleColor__SRlJN`,
	"greyColor": `Textarea_greyColor__2M5o-`,
	"redColor": `Textarea_redColor__GtlkW`,
	"container": `Textarea_container__M5+1Y`,
	"fSixBackground": `Textarea_fSixBackground__8cEsN`,
	"transparentBgc": `Textarea_transparentBgc__eVUvk`,
	"label": `Textarea_label__08PBr`,
	"labelMrginStart": `Textarea_labelMrginStart__zf-fW`,
	"labelUp": `Textarea_labelUp__Wwre2`,
	"labelUpMore": `Textarea_labelUpMore__2lSog`,
	"labelDown": `Textarea_labelDown__OvJoL`,
	"textarea": `Textarea_textarea__GOA-G`,
	"allBorderTextarea": `Textarea_allBorderTextarea__Cpe-k`,
	"bottomBorderTextArea": `Textarea_bottomBorderTextArea__jZPL-`,
	"ltrInput": `Textarea_ltrInput__wpvta`,
	"helperTxtContainer": `Textarea_helperTxtContainer__+m2SS`,
	"helperTxtIcon": `Textarea_helperTxtIcon__01hHS`,
	"helperTxt": `Textarea_helperTxt__SeHuA`,
	"questionIcon": `Textarea_questionIcon__0ql4c`,
	"tooltip": `Textarea_tooltip__UaFZ7`,
	"notif": `Textarea_notif__cB-n7`,
	"hcmContainer": `Textarea_hcmContainer__P76NW`,
	"hcmTextarea": `Textarea_hcmTextarea__OMfk3`
};
export default ___CSS_LOADER_EXPORT___;
